import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, selectedAdmin: admin, error, message, newAdmin,
  } = state.admin;
  return {
    isLoading,
    admin,
    error,
    message,
    newAdmin,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
